/**
 * retroPosters — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const retroPostersPack: ToilePack = {
    slug: 'retro-posters',
    category: 'retroposter',
    name: 'Retro sci-fi posters',
    tagline: tagline('posters', 'scenes', 'styles'),
    chips: chips('scenes', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'raygun', label: 'Ray Gun', subject: 'a spaceman in a finned helmet leveling a ray gun, a rocket behind'},
        {key: 'vista', label: 'Red World', subject: 'twin suns over red rock arches, a domed colony in the valley'},
        {key: 'robots', label: 'Uprising', subject: 'riveted robots marching over a burning city, searchlights raking'},
    ],
    styles: [
        {key: 'pulp', label: '50s pulp', style: 'lurid painted illustration, airbrushed rays', palette: 'saturated reds and yellows, aged newsprint', framing: 'tall poster, slab-serif title'},
        {key: 'constructivist', label: 'Constructivist', style: 'hard diagonal composition, cut-paper geometric shapes', palette: 'flat red, black and cream', framing: 'tall poster, condensed title on an angle'},
        {key: 'minimal', label: 'Minimalist', style: 'a single bold graphic shape on a flat ground', palette: 'three flat colors, generous empty space', framing: 'tall poster, small sans-serif title'},
    ],
    directions: ['a lost-planet jungle instead', 'in acid green and black', 'quieter, more menace than action'],
}
